import NewFinance from "../features/finance/NewFinance"

const NewFinancePage = () => {
    return (
        <>
            <NewFinance />
        </>
    )
}

export default NewFinancePage